import { Arg, Entity, Field, Subscription } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import { selectionSet, type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Base } from '@adornis/buildify/db/Base.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { switchMap } from 'rxjs';

@Entity()
export class GlobalComponent extends MongoEntity {
  static override _class = 'GlobalComponent';
  static override _collectionName = 'global-components';

  static get identifier() {
    return {
      GLOBAL_NAV: 'global-nav',
      GLOBAL_FOOTER: 'global-footer',
      NOT_FOUND_PAGE: 'not-found-page',
    };
  }

  static override get allFields() {
    return selectionSet(() => this, 5);
  }

  @validate(nonOptional())
  @Field(type => [Base], { default: v => v ?? [] })
  content!: Base[];

  @Subscription(type => GlobalComponent)
  static subscribeAndEnsureGlobalComponent(@Arg('identifier', type => String) identifier: string) {
    return (gqlFields: BaseQLSelectionSet<GlobalComponent>) => {
      return watchQuery(GlobalComponent._collectionName, { _id: identifier }).pipe(
        switchMap(async () => {
          const rawGlobalCollection = await getRawCollection<GlobalComponent>(this._collectionName);
          const existingEntry = await rawGlobalCollection.findOne<GlobalComponent>({ _id: identifier });
          if (existingEntry) return existingEntry;
          const newEntry = new GlobalComponent({ _id: identifier, content: [] });
          const insertedID = await newEntry.create();
          newEntry._id = insertedID;
          return newEntry;
        }),
      );
    };
  }
}
